import { render, staticRenderFns } from "./TransactionLedger.vue?vue&type=template&id=5191360f&"
import script from "./TransactionLedger.vue?vue&type=script&lang=js&"
export * from "./TransactionLedger.vue?vue&type=script&lang=js&"
import style0 from "./TransactionLedger.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports